const BASE = 16;

const fonts = {
  family: {
    japanese: 'fot-chiaro-std, sans-serif',
    proximaNova: 'proxima-nova, sans-serif',
    sourceCodePro: 'source-code-pro, monospace',
  },
  size: {
    base: BASE,
    mobile: BASE,
    desktop: BASE * 1.125,
  },
};

export default fonts;
export { BASE };
